import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import classnames from "classnames";
import { GreenPlusCircle } from "../../icons";
import { ToutCheckMark } from ".";
import PremiumUpgradeModal from "./PremiumUpgradeModal";

import "./PremiumSellerUpgradeModal.scss";

interface IProps {
  handleClose: () => void;
  show: boolean;
  upgradeButton: React.ReactNode;
}

const PremiumSellerUpgradeHeader = () => (
  <div
    className={classnames(
      "PremiumSellerUpgradeModal__headerPadding",
      "PremiumSellerUpgradeModal__header"
    )}
  >
    <div className="PremiumSellerUpgradeModal__premium">PREMIUM SELLER</div>
    <div>
      <span className="PremiumSellerUpgradeModal__price">$59.95/year</span>
      <span className="PremiumSellerUpgradeModal__priceComment">
        (that&apos;s less than $5/month!)
      </span>
    </div>
  </div>
);

const PremiumSellerUpgradeBody = ({
  upgradeButton,
}: {
  upgradeButton: React.ReactNode;
}) => (
  <div className="PremiumSellerUpgradeModal__contentPadding">
    <Row className="PremiumSellerUpgradeModal__row">
      <Col className="PremiumSellerUpgradeModal__col" md={6}>
        <div className="PremiumSellerUpgradeModal__descriptionHeader">
          Everything in Free, plus:
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />A larger selection of fonts and colors
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />
          Additional upload capacity
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />
          Ability to add audio
        </div>
      </Col>
      <Col className="PremiumSellerUpgradeModal__col" md={6}>
        <div className="PremiumSellerUpgradeModal__descriptionHeader">
          Additonal benefits for your TpT Store:
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />
          Higher payout rate on each sale
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />
          Reduced transaction fees
        </div>
        <div className="PremiumSellerUpgradeModal__bulletPoint">
          <ToutCheckMark />
          Ability to upload videos and bigger file sizes
        </div>
        <div className="PremiumSellerUpgradeModal__customBulletPoint">
          <div className="PremiumSellerUpgradeModal__circle">
            <GreenPlusCircle />
          </div>
          <div>
            More Premium Seller Membership features and tools.{" "}
            <a
              href="https://help.teacherspayteachers.com/hc/en-us/articles/360044219891-Seller-Fees-and-Payout-Rates"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn More
            </a>
          </div>
        </div>
      </Col>
    </Row>
    <div className="PremiumSellerUpgradeModal__upgradeButton">
      {upgradeButton}
    </div>
  </div>
);

export const PremiumSellerUpgradeModal = ({
  show,
  handleClose,
  upgradeButton,
}: IProps) => {
  return (
    <PremiumUpgradeModal
      show={show}
      dialogClassName="SellerUpgradeToutModal"
      handleClose={handleClose}
      body={<PremiumSellerUpgradeBody upgradeButton={upgradeButton} />}
      header={<PremiumSellerUpgradeHeader />}
    />
  );
};

export default PremiumSellerUpgradeModal;
